export const LIGNES_COMMANDE_MANAGER = {
  titleLigneCmd: 'Liste des lignes de commande',
  titleARenouveler: 'Liste des lignes de commande à renouveler',
  onglet: {
    lignesCommande: 'Lignes commande',
    aRenouveler: 'A renouveler',
  },
};

export const LISTE_LIGNES_COMMANDE = {
  tabs: {
    planMedia: 'N° Plan media',
    codeCommande: 'N° cmd.',
    codeCommandePlanMVentes: 'N°.',
    produit: 'Produit',
    dateCommande: 'Date cmd.',
    dateCommandePlanMVentes: 'Date.',
    commercial: 'Commercial',
    clients: 'Client(s)',
    etat: 'Etat cmd.',
    etatPlanMVentes: 'Etat.',
    dateCampagne: 'Date campagne',
    dateDebut: 'Date début ligne',
    dateFin: 'Date fin ligne',
    codeDossier: 'Code dossier',
    montantHt: 'Mnt HT cmd.',
    montantHtPlanMVentes: 'Mnt HT.',
    totalHt: 'Total HT ligne',
    typeProduit: 'Type de produit',
    patrimoine: 'Patrimoine',
    type: 'Type de document',
  },
  filtre: {
    title: 'Filtre',
    sousTitle: 'Les filtres seront appliqués à la liste',
    datePremierAffichage: 'Date de campagne',
    au: 'au',
    clients: 'Clients',
    codePM: 'N° Plan media',
    code: 'N° cmd',
    etat: 'Liste des états',
    commercial: 'Commercial',
    referenceClient: 'Référence client',
    agence: 'Agence(s)',
    codeDossier: 'Code(s) dossier',
    fournisseur: 'Fournisseur(s)',
    assistant: 'Assistant',
    sansAssistant: 'Sans assistant',
    noCommercial: 'Sans commercial',
    libelleProduit: 'Libellé produit',
    produits: 'Produits',
    enseigne: 'Enseigne(s)',
    groupe: 'Groupe(s)',
    typeProduit: 'Type(s) de produit',
    interne: 'Commande interne',
    typesDevisCommandeFacture: 'Type(s) de document',
    patrimoine: 'Patrimoines',
    typePatrimoine: 'Type(s) de patrimoine',
    error: {
      errorDatePremierAffichage: 'La date de début de campagne est supérieure à la date de fin',
    },
  },
};

export const LISTE_LIGNES_COMMANDE_A_RENOUVELER = {
  tabs: {
    etat: 'Etat',
    code: 'N° cmd',
    codeDossier: 'Code Dossier',
    produit: 'Produit',
    commercial: 'Commercial',
    payeur: 'Payeur',
    annonceur: 'Annonceur',
    montantHt: 'Mnt HT cmd.',
    totalHt: 'Total HT ligne',
    typeProduit: 'Type de produit',
    dateDebut: 'Date début ligne',
    dateFin: 'Date fin ligne',
    datePreavis: 'Date préavis',
    dateDemande: 'Date demande',
    dateRenouvellement: 'Date renouvellement',
    motif: 'Motif non renouvellement',
    groupe: 'Groupe',
    enseigne: 'Enseigne',
    marques: 'Marques',
    quantite: 'Quantité',
    soldeStock: 'Solde du stock',
  },
  actions: {
    renouveler: 'Renouveler',
    pasRenouveler: 'Ne pas renouveler',
    reconduireTacitement: 'Reconduire tacitement',
    aRenouveler: 'A renouveler',
    enCours: 'En cours de renouvellement',
  },
  filtre: {
    etat: 'Etat',
    codeDossier: 'Code(s) dossier',
    numeroCommande: 'N° cmd',
    payeurs: 'Payeurs',
    annonceurs: 'Annonceurs',
    commercial: 'Commercial',
    periode: 'Période',
    parDateDe: 'Par date de',
    enseigne: 'Enseigne(s)',
    groupe: 'Groupe(s)',
    produit: 'Produit',
    fournisseur: 'Fournisseur(s)',
    typeProduit: 'Type(s) de produit',
    agence: 'Agence(s)',
    produitRenouvelable: 'Produit renouvelable',
    actions: {
      reinitialiser: 'Réinitialiser',
      appliquer: 'Appliquer',
    },
    choixDates: {
      renouvellement: 'Renouvellement',
      preavis: 'Préavis',
    },
    error: {
      dateWithFilterTypeEmpty: 'Le type de date est obligatoire pour filtrer sur une période.',
      filterTypeWithEmptyDate: 'La période est obligatoire pour filtrer par date.',
    },
  },
  popUpPrevention: {
    messHeader: 'Etes-vous sûr de vouloir passer votre commande à l\'état "{etat}" ?',
    messFooter: 'Attention, cela changera l\'état de toute la commande liée à la ligne de commande',
  },
  messages: {
    success: {
      changeEtat: 'L\'état de renouvellement de la commande a bien été modifié.',
      changeEtatEnCoursMultiCommande: 'Les commandes ont été passées à l\'état \'En cours de renouvellement\' avec succès',
      changeEtatEnCours: 'La commande a été passée à l\'état \'En cours de renouvellement\' avec succès',
    },
    error: {
      badEtatForChangeEtatEnCours: 'Les commandes suivantes ne peuvent pas êtres passées à l\'état \'En cours de renouvellement\' :',
      badEtatForChangeEtatEnCoursDes: 'Veuillez-les passer à l\'état \'En cours de renouvellement\' ou \'A renouveler\'',
    },
  },
};
